module.exports = __webpack_public_path__ + "img/down_qa.4ef86ae4.svg";